import { render, staticRenderFns } from "./MarketingBanner.vue?vue&type=template&id=0f216307&scoped=true"
import script from "./MarketingBanner.vue?vue&type=script&lang=js"
export * from "./MarketingBanner.vue?vue&type=script&lang=js"
import style0 from "./MarketingBanner.vue?vue&type=style&index=0&id=0f216307&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f216307",
  null
  
)

export default component.exports